module.exports = __webpack_public_path__ + "img/role1.348e4644.png";